import { BannerColorPalette } from '../interface';
import { BannerData } from './interface';

export const DEFAULT_BANNER_DATA: BannerData = {
  color: BannerColorPalette.INFO,
  message: '',
  canClose: true,
  thumbnailName: 'error-filled'
};
